import { BookingResponse } from "../../models/ResponseModels/BookingResponse";
import { AppColors } from "../../constants/AppColors";

export type BookingColorMap = {
  paid: string;
  unpaid: string;
  deposit: string;
  cancelled: string;
};

export const getBookingColor = (
  booking?: BookingResponse,
  bookingColors: BookingColorMap = AppColors.booking,
): string => {
  if (!booking) {
    return "#ffffff";
  }

  if (booking.status === "cancelled") {
    return bookingColors.cancelled;
  }

  if (booking.payment_status === "paid") {
    return bookingColors.paid;
  }

  if (booking.payment_status === "deposit") {
    return bookingColors.deposit;
  }

  return bookingColors.unpaid;
};

export const darkenHexColor = (hexColor: string, amount = 35) => {
  const normalizedHex = hexColor.replace("#", "");

  if (!/^[0-9A-Fa-f]{6}$/.test(normalizedHex)) {
    return hexColor;
  }

  const red = Math.max(0, parseInt(normalizedHex.slice(0, 2), 16) - amount);
  const green = Math.max(0, parseInt(normalizedHex.slice(2, 4), 16) - amount);
  const blue = Math.max(0, parseInt(normalizedHex.slice(4, 6), 16) - amount);

  return `#${red.toString(16).padStart(2, "0")}${green
    .toString(16)
    .padStart(2, "0")}${blue.toString(16).padStart(2, "0")}`;
};
